import { DEV_ACCOUNT_EMAILS, SHOW_EV_SPECIFICATION_COOKIE } from './devTools.consts';

export const isDevAccount = (user: Nullable<Record<string, unknown>> | undefined): boolean => {
	const email = user?.email;
	return typeof email === 'string' && DEV_ACCOUNT_EMAILS.has(email.trim().toLowerCase());
};

export const isShowEvSpecificationRequested = (cookies: Partial<Record<string, string>> | undefined): boolean =>
	cookies?.[SHOW_EV_SPECIFICATION_COOKIE] === 'true';
